import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "create-language-variation-modal" */'./CreateLanguageVariationModal').then(mod => mod.default),
  LoadingComponent: () => null
});